const CategoryType = Object.freeze({
    FOODS: 'FOODS',
    DRINKS: 'DRINKS',
});

module.exports = CategoryType;
